module.exports = __webpack_public_path__ + "img/menu.80f3ba95.svg";